/*
 * Exceptions reducer
 */
import { fromJS, Map } from 'immutable'
import { ActionTypes } from './constants'

const initialState = fromJS({
  exceptions: Map(),
  errors: Map(),
})

function reducer(state = initialState, { payload, type }) {
  switch (type) {
    case ActionTypes.FETCH_EXCEPTIONS_FULFILLED: {
      const { storeId, exceptions } = payload
      return state.set(
        'exceptions',
        state.get('exceptions').set((storeId || -1).toString(), exceptions)
      )
    }
    case ActionTypes.FETCH_EXCEPTIONS_FAILED:
      return state.set(
        'errors',
        state.get('errors').set((payload.storeId || -1).toString(), payload)
      )
    case ActionTypes.LOAD_EXCEPTIONS_ASYNC_COUNT:
      return state.set('storesToLoadCount', payload)
    case ActionTypes.LOAD_EXCEPTIONS_ASYNC_CURRENT:
      return state
        .set('currentStoreLoading', payload.store)
        .set('currentIndexLoading', payload.index)
    case ActionTypes.LOAD_EXCEPTIONS_ASYNC_FINISHED:
      return state
        .set('currentStoreLoading', null)
        .set('storesToLoadCount', 0)
        .set('currentIndexLoading', 0)
    case ActionTypes.LOAD_EXCEPTIONS_ASYNC_CANCEL:
      return state.set('asyncLoadingCanceling', true)
    case ActionTypes.EXCEPTIONS_CLEAR:
      return state
        .set('exceptions', Map())
        .set('asyncLoadingCanceling', false)
        .set('errors', Map())
    default:
      return state
  }
}

export default reducer
